import PMCSidebar from "../Pmc/PMCSidebar";
import { GridDashBoard } from "../../style/Dashboard";
import PMCHeader from "./PMCHeader";
import "./Pmc.css"
import "../../component/Navbar/Navbar.css"
// config/sidebarConfig.js
import EligiableImg from "../../assets/Pmc/Ads/Asset-21.png";
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";
import { PMCContainer, CustomLink } from "../../style/PMCStyle/PMCTab";
import Router from '../../Routes'
import Photo from "../../assets/Pmc/johnImage.png";
import { ContainerWrapper, Image, H3 } from "../../style/PMCStyle/PCMDashboard";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import "../People/anima.css";
export const sidebarConfig = [
  {
    path: "",
    icon: Cal,
    activeIcon: CalA,
    alt: "Cal",
  },
  {
    path: "/Pmc/dashboard",
    icon: User,
    activeIcon: UserA,
    alt: "User",
  },
  {
    path: "",
    icon: Menu,
    activeIcon: MenuA,
    alt: "Menu",
  },
  {
    path: "",
    icon: Person,
    activeIcon: PersonA,
    alt: "Person",
  },
];
export default function PharmacyManagementSystem() {
  const history = useHistory()
  let headerVisibility = false;
  if (history.location.pathname === "/Pmc/pricing" || history.location.pathname === "/Pmc/dispensed") {
    headerVisibility = true;
  } else {
    headerVisibility = false;
  }
  return (
    <>
      <GridDashBoard>
        <div className="desk-visibility">
          <PMCSidebar config={sidebarConfig} />
          <div className="desk-navbar-wrap">
            <div className="conatiner">
              <PMCHeader />
            </div>
          </div>
        </div>

        <div className="customeGridArea">
          <div className="conatiner">
            <ContainerWrapper>
              <Grid container style={{ alignItems: "center" }}>
                <Grid
                  item
                  md={headerVisibility ? 4 : 12}
                  xs={12}
                  sm={12}
                  className="d-flex headerSection"
                >
                  <Image src={Photo} alt="photo" className="smResponsive Text-center" />
                  <div className="smResponsive Text-center" style={{ width: "calc(100% - 115px)" }}>
                    <H3 style={{ marginTop: "2px" }}>
                      Pharmacist :{" "}
                      <span style={{ color: "#4678ED" }}>John Smith</span>
                    </H3>
                    <H3>ID : 123456</H3>
                  </div>
                </Grid>
                {headerVisibility && (
                  <Grid item md={8} xs={12} sm={12} className="responsiveImage">
                    <img src={EligiableImg} alt="" />
                  </Grid>
                )}
              </Grid>
            </ContainerWrapper>
            <Grid container style={{ marginBottom: "10px" }}>
              <PMCContainer className="tab-custom-css">
                <CustomLink
                  activeClassName="TabActive"
                  to="/Pmc/dashboard"
                >
                  Dashboard
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/Pmc/pendingrx"
                >
                  Pending Rx
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/Pmc/rxdocs"
                  onClick={(e) => e.preventDefault()}
                >
                  RxDocs
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/Pmc/pricing"
                >
                  Pricing
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/Pmc/dispensed"
                  onClick={(e) => e.preventDefault()}
                >
                  Dispensed
                </CustomLink>
              </PMCContainer>
            </Grid>
            <div>
              <Router />
            </div>
          </div>
        </div>
      </GridDashBoard>
    </>
  )
}